import { Plugin } from "@ckeditor/ckeditor5-core";
import { toWidget } from "@ckeditor/ckeditor5-widget/src/utils";
import { Widget } from "@ckeditor/ckeditor5-widget";

import CreateLineRefsCommand from "./CreateLineRefsCommand";

export default class LineRefsEditing extends Plugin {
  static get requires() {
    return [Widget];
  }

  init() {
    this._defineSchema();
    this._defineConverters();

    this.editor.commands.add(
      "createLineRef",
      new CreateLineRefsCommand(this.editor, true),
    );

    if (this.editor.plugins.has("TrackChangesEditing")) {
      const trackChangesEditing = this.editor.plugins.get(
        "TrackChangesEditing",
      );
      trackChangesEditing.enableCommand("createLineRef");
    }
  }

  _defineConverters() {
    const editor = this.editor;
    const conversion = editor.conversion;

    const createLineRefElement = (modelElement, viewWriter, isData = true) => {
      const position = modelElement.getAttribute("position");
      if (isData) {
        return viewWriter.createEmptyElement(`${position}Line`);
      } else {
        const element = viewWriter.createContainerElement(`${position}Line`, {
          title: `Line Ref ${position}`,
        });
        switch (position) {
          case "end":
            viewWriter.insert(
              viewWriter.createPositionAt(element, "end"),
              viewWriter.createText("\u22a3"),
            );
            break;
          case "start":
            viewWriter.insert(
              viewWriter.createPositionAt(element, "end"),
              viewWriter.createText("\u22a2"),
            );
            break;
        }
        return element;
      }
    };

    // Block LineRef Element conversions
    conversion.for("dataDowncast").elementToElement({
      model: "lineRef",
      view: (modelElement, { writer: viewWriter }) => {
        return createLineRefElement(modelElement, viewWriter, true);
      },
    });
    conversion.for("editingDowncast").elementToElement({
      model: "lineRef",
      view: (modelElement, { writer: viewWriter }) => {
        const lineRef = createLineRefElement(modelElement, viewWriter, false);
        return toWidget(lineRef, viewWriter);
      },
    });
    conversion.for("upcast").elementToElement({
      model: (viewElement, { writer: modelWriter }) => {
        const position = "start";
        return modelWriter.createElement("lineRef", {
          position,
        });
      },
      view: "startline",
    });
    conversion.for("upcast").elementToElement({
      model: (viewElement, { writer: modelWriter }) => {
        const position = "end";
        return modelWriter.createElement("lineRef", {
          position,
        });
      },
      view: "endline",
    });
  }

  _defineSchema() {
    const schema = this.editor.model.schema;

    schema.register("lineRef", {
      allowAttributes: ["position"],
      allowContentOf: "$text",
      allowWhere: "$text",
      isInline: true,
      isObject: true,
    });
  }
}
